import React, { useEffect, useState } from 'react';

export const Dashboard = () => {
    return (
        <>
            Environment: {process.env.NODE_ENV}<br />
            APIBase: {process.env.REACT_APP_APIBASE}
        </>
    )
}